import React from 'react';
import './heade.css';
function Header() {
    return (
        <div >
          <div className="hed">
              <div className="he"></div>
              <p>The Maze</p>
          </div>
        </div>
    )
}

export default Header
